interface ProgressIndicatorProps {
  currentStep:
    | 'trainingLanding'
    | 'training'
    | 'intro'
    | 'avatar'
    | 'big5'
    | 'values'
    | 'interests'
    | 'futureSelves'
    | 'avatarFeedback';
  className?: string;
}

const steps = [
  { id: 'avatar', label: 'Create Avatar' },
  { id: 'big5', label: 'Personality' },
  { id: 'values', label: 'Values' },
  { id: 'interests', label: 'Interests' },
  { id: 'futureSelves', label: 'Future Selves' },
  { id: 'avatarFeedback', label: 'Feedback' },
];

export function ProgressIndicator({ currentStep, className = '' }: ProgressIndicatorProps) {
  // Don't show progress indicator for training phases
  if (currentStep === 'trainingLanding' || currentStep === 'training' || currentStep === 'intro') {
    return null;
  }

  const currentIndex = steps.findIndex(step => step.id === currentStep);

  return (
    <div
      className={`tw-w-full tw-max-w-full tw-flex tw-items-center tw-bg-white tw-border-b tw-border-gray-200 ${className}`}
      style={{ minHeight: '72px' }}
    >
      <div className="tw-flex tw-items-center tw-w-full tw-min-w-0 tw-px-3 md:tw-px-5 tw-gap-1">
        {steps.map((step, index) => {
          const isPast = index < currentIndex;
          const isCurrent = index === currentIndex;

          return (
            <div key={step.id} className="tw-flex tw-items-center tw-flex-1 tw-min-w-0">
              {/* Step indicator */}
              <div className="tw-flex tw-items-center tw-gap-2 tw-min-w-0">
                <div
                  className={`tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-rounded-full tw-transition-all ${
                    isCurrent
                      ? 'tw-bg-blue-600 tw-text-white'
                      : isPast
                      ? 'tw-bg-gray-800 tw-text-white'
                      : 'tw-bg-gray-200 tw-text-gray-500'
                  }`}
                >
                  {index + 1}
                </div>
                <span
                  className={`tw-hidden lg:tw-inline tw-truncate tw-text-sm xl:tw-text-base ${
                    isCurrent || isPast ? 'tw-font-bold' : 'tw-font-normal'
                  } ${isCurrent ? 'tw-text-blue-600' : isPast ? 'tw-text-gray-800' : 'tw-text-gray-500'}`}
                >
                  {step.label}
                </span>
              </div>

              {/* Connector line */}
              {index < steps.length - 1 && (
                <div
                  className={`tw-mx-2 tw-flex-1 tw-min-w-2 tw-h-[3px] ${isPast ? 'tw-bg-gray-800' : 'tw-bg-gray-200'}`}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
